import { useCallback, useEffect, useRef } from "react";
import { toast } from "react-hot-toast";
import { DataStudioExportRequest, startExportAndDownload } from "../../services/ApiService.ts";

/** Runs a Data Studio export to completion, aborting the status poll when the caller unmounts. */
export const useExportDownload = () => {
  const abortRef = useRef<AbortController | null>(null);

  useEffect(() => () => abortRef.current?.abort(), []);

  return useCallback(async (request: DataStudioExportRequest) => {
    abortRef.current?.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    const toastId = toast.loading("Download wordt voorbereid...");
    try {
      await startExportAndDownload(request, undefined, controller.signal);
      toast.success("Data gedownload", { id: toastId });
    } catch (error) {
      if (error instanceof DOMException && error.name === "AbortError") {
        toast.dismiss(toastId);
        return;
      }
      toast.error(error instanceof Error ? error.message : "Fout bij downloaden van data", { id: toastId });
    }
  }, []);
};
